import { GridFilterModel } from "@mui/x-data-grid-pro";


export interface LazyLoadEventModel {
    filterConditionalOperator:string;
    filters: LazyloadingFilters[];
    first: number;
    globalFilter: any;
    rows: number;
    sortOrder: number;
    
}

export interface LazyloadingFilters {
    value?: any; //value
    matchMode?: string; //operator
    identity: string; //field
}

export interface InvestmentMasterModel {
    id: string;
    investmentId: string;
    name: string;
    fundId: string;
    fund: string;
    assetManager: ApplicationUser;
    asstPortfolioManager: ApplicationUser;
    assetManagerName: string;
    investmentType: string;
    propertyType: string;
    city: string;
    state: string;
    country: string;
    hasDebtLiability: boolean;
    lastAnnualAppraisedValue: number;
    status: string;
    portfolioManager: ApplicationUser;
    assetManagerHead: ApplicationUser;
    sectorHead: ApplicationUser;
    xmin: number;
    createdBy: string;
    created: string;
    lastModifiedBy: string;
    lastModified: string;
    lastSyncedOn: string;
    fgInvestmentAppraisalValues: InvestmentMasterAppraisalValue;
    assets: Asset[];
}

export interface InvestmentMasterAppraisalValue {
    lastAppraisedValue: number;
    lastAnnualAppraisedValue: number;
    nextAppraisalDate: string;
    appraisalStatus: string;
    lastAppraisalDate: string;
    lastAnnualAppraisalDate: string;
    lastAppraisalType: string;
    lastDLAppraisedValue: number;
    lastDLAnnualAppraisedValue: number;
    lastDLAppraisalDate: string;
    lastDLAnnualAppraisalDate: string;
}

export interface Asset {
    id: string;
    name: string;
    status: string;
    investmentId: string;
    currentAppraisalValue: number;
    lastAppraisedValue: number;
    lastAnnualAppraisedValue: number;
    createdBy: string;
    created: string;
    lastModifiedBy: string;
    lastAppraisalDate: string;
    lastAnnualAppraisalDate: string;
    lastModified: string;
}

export interface ApplicationUser {
    firstName: string;
    lastName: string;
    email: string;
}

export interface Funds {
    id: number;
    fundID: string;
    fundName: string;
    region: string;
    createdBy: string;
    created: string;
    lastModifiedBy: string;
    lastModified: string;
}

export interface InvestmentIDsModel {
    investmentId: string
    name: string
    fundId: string
    investmentType: string
}

export interface UserRoleMapModel {
    id: number;
    userroleid: string;
    userName: string;
    userID: string;
    userType: string;
    email: string;
    role: string;
    fundId: string;
    fundName: string;
    investmentType: string;
    firm: string;
    status: string;
    firstName: string;
    lastName: string;
    region: string;
    xmin: number;
    isDeletedAndArchived: boolean;
    createdBy: string;
    created: string;
    lastModifiedBy: string;
    lastModified: string;
}

export interface DocumentTypesModel {
    id: number;
    name: string;
    tag: string;
    appraisalCycle: string;
    investmentType: string;
    sortOrder: number;
    region: string;
}

export interface ExternalAppraisersModel {
    id: number;
    name: string;
    appraisalFirm: string;
    email: string;
    region: string;
    status: string;
    createdBy: string;
    created: string;
    lastModifiedBy: string;
    lastModified: string;
}

export interface AllCountriesModel {
    id: number;
    countryName: string;
    countryCode: string;
    localId: string;
}

export class AppraisalsDetailsModelForEquity {

    currencySelected!: string;
    currentAppraisalValue!: number | null | string;
    effectiveDateOfValue!: string;
    GPAppraisalValue!:number  | null | string;
    sheduled_n_cost!: number | null | string;
    lastAppraisedValue!: number | null | string;
    lastAppraisalPercentageChange!: number | null | string;
    lastAppraisedDate!: string;
    lastAnnualAppraisedValue!: number | null | string;
    lastAnnualAppraisalPercentageChange!: number  | null | string;
    lastAnnualAppraisedDate!: string;
}

export class AppraisalDetailsModelForCM {
    currencySelected!: string;
    propertyValueAsIs!: number | null | string;
    propertyValueAsIsDate!: string;
    capRateAsIs!: number  | null | string;
    propertyValueStabilized!: number | null | string;
    propertyValueStabilizedDate!: string;
    capRateStabilized!: number | null | string;
    propertyInsurableValue!: number | null | string;
    propertyLandValue!: number | null | string;
    reportDate!: string;
}

export class AppraisalAssetsModel {
    id!: string;
    name!: string;
    investmentId!: string;
    currentAppraisalValue!: number | null | string;
    lastAppraisedValue!: number  | null | string;
    lastAnnualAppraisedValue!: number  | null | string;
    status!: string;
    lastAppraisalDate!: string;
    lastAnnualAppraisalDate!: string;
    createdBy!: string;
    created!: string;
    lastModifiedBy!: string;
    lastModified!: string;
    lastSyncDate!: string;
    dcfValue!: number  | null | string;
    discountRate!: number  | null | string;
    terminalCapRate!: number  | null | string;
    impliedCapRateYr1!: number  | null | string;
    impliedCapRateAvYr1To5!: number  | null | string;
    argusPropertyAssetId!: string;
    argusSubmissionId!: string;
    directRate!: number  | null | string;
}

export class FileChunk {

    fileName!: string;
    fileSize!: number;
    guid!: string;
    doctype!: string;
    lastModifiedTime!: number;
    lastModifiedDate!:  string|Date | null;
    fileAsBase64!: string ;
    fileUrl!: string ;
    fileUrlExpire!: number ;
    fileKey!: string ;
    lastModifiedBy!: string;
    fileIndex!: number;
    tmpDirectory!: string;
}


export class InvestmentForAppraisalModel {
    id!: string;
    investmentId!: string;
    name!: string;
    fundId!: string;
    fund!: string;
    assetManager!: ApplicationUser;
    assetManagerName!: string;
    investmentType!: string;
    propertyType!: string;
    city!: string;
    state!: string;
    country!: string;
    hasDebtLiability!: boolean;
    lastAnnualAppraisedValue!: number;
    status!: string;
    portfolioManager!: ApplicationUser;
    assetManagerHead!: ApplicationUser;
    sectorHead!: ApplicationUser;
    xmin!: number;
    createdBy!: string;
    created!: string;
    lastModifiedBy!: string;
    lastModified!: string;
    lastSyncedOn!: string;
    fgInvestmentAppraisalValues!: InvestmentMasterAppraisalValue;
    assets!: AppraisalAssetsModel[];
}

export class AppraisalDetailsModelForDLorDA {
    currencySelected!: string;
    currentDebtValue!: number | null | string;
    currentPrincipalValue!: number | null | string;
    loanToValueRatio!: number | null | string;
    treasuryRate!: number | null | string;
    riskPremium!: number | null | string;
    surveyYield!: number | null | string;
    currentEffectiveDate!: string;
    derivative!: number | null | string;
    lastDebtValue!: number | null | string;
    lastDebtPercentageChange!: number | null | string;
    lastDebtEffectiveDate!: string;
}

export class AppraisalAttachment {
    file!: any;
    guid!: string;
    doctype!: string;
    fileName!: string;
    fileSize!: number;
    fileType!: string;
    lastModifiedTime!: number;
    lastModifiedDate!: any;
    fileAsBase64!: string;
    fileUrl!: string;
    fileUrlExpire!: number;
    fileKey!: string;
    lastModifiedBy!: string;
    scenarioId!: string;
}

export class UploadPreSignedPayloadModel {
    guid!: string;
    doctype!: string;
    fileName!: string;
    fileSize!: number;
    fileType!: string;
    lastModifiedTime!: number;
    lastModifiedDate!: string | Date;
    fileAsBase64!: string;
    fileUrlExpire!: number;
    lastModifiedBy!: string;
    scenarioId!:string;
}


export class AppraisalModel {
    GUID!: string;
    AppraisalId!: string;
    Fund!: string;
    FundId!: string;
    InvestmentId!: string;
    InvestmentName!: string;
    Status!: string;
    ValueDate!: string|Date | null;
    Appraiser1!: ApplicationUser;
    Appraiser2!: ApplicationUser;
    Appraiser3!: ApplicationUser;
    Fiduciary!: ApplicationUser;
    AppraiserFirm!: string;
    ExternalAppraiser!: string;
    AppraisalType!: string;
    CurrentAppraisalValue!: number | null | string;
    currentPrincipalValue!: number | null | string;
    loanToValueRatio!: number | null | string;
    treasuryRate!: number | null | string;
    riskPremium!: number | null | string;
    surveyYield!: number | null | string;
    Type!: string;
    City!: string;
    State!: string;
    AssetManager!: ApplicationUser;
    HasDebtLiability!: boolean;
    LastAppraisedValue!: number | null | string;
    LastAnnualAppraisedValue!: number | null | string;
    AnnualPercentageChange!: number | null | string;
    PercentageChange!: number | null | string;
    AssetManagerHead!: ApplicationUser;
    InvestmentPropertyType!: string;
    InvestmentType!: string;
    PortfolioManager!: ApplicationUser;
    SectorHead!: ApplicationUser;
    CanSubmit!: boolean;
    CreatedBy!: string;
    Created!: string;
    LastModifiedBy!: string;
    LastModified!: string;
    AppraisalRejected!: boolean;
    Xmin!: number;
    LastAppraisalDate!: string;
    LastAnnualAppraisalDate!: string;
    ScheduleNCost!: number | null | string;
    Currency!: string;
    Derivative!: number | null | string;
    PropertyValueAsIs!: number | null | string;
    PropertyValueAsIsDate!: string;
    PropertyValueStabilized!: number | null | string;
    PropertyValueStabilizedDate!: string;
    CapRateAsIs!: number | null | string;
    Stage!: string;
    CapRateStabilized!: number | null | string;
    ReportDate!: string;
    Assets: AppraisalAssetsModel[] = [];
    WorkflowId!: string;
    Country!: string;
    WorkflowSteps!: string;
    PropertyLandValue!: number | null | string;
    PropertyInsurableValue!: number | null | string;
    IsDeleted!: boolean;      
    GPAppraisalValue!:number | null | string;
    ActiveIndex!:number | null;
    ValuationType!:number | null | string;
    ClaimedBy!:ApplicationUser;
    Frequency!:string;

}

export class Appraisal {
    AppraisalId!: string;
    Status!: string;
    ValueDate!: string;
    Appraiser1!: ApplicationUser;
    Appraiser2!: ApplicationUser;
    Appraiser3!: ApplicationUser;
    Fiduciary!: ApplicationUser;
    AppraiserFirm!: string;
    ExternalAppraiser!: string;
    AppraisalType!: string;
    CurrentAppraisalValue!: number;
    currentPrincipalValue!: number;
    loanToValueRatio!: number;
    treasuryRate!: number;
    riskPremium!: number;
    surveyYield!: number;
    PercentageChange!: number;
    AnnualPercentageChange!: number;
    InvestmentId!: string;
    InvestmentName!: string;
    Fund!: string;
    FundId!: string;
    InvestmentType!: string;
    InvestmentPropertyType!: string;
    City!: string;
    State!: string;
    HasDebtLiability!: boolean;
    LastAppraisedValue!: number;
    LastAnnualAppraisedValue!: number;
    AssetManager!: ApplicationUser;
    PortfolioManager!: ApplicationUser;
    AssetManagerHead!: ApplicationUser;
    SectorHead!: ApplicationUser;
    WorkflowId!: string;
    Stage!: string;
    xmin!: number;
    CanSubmit!: boolean;
    CreatedBy!: string;
    Created!: string;
    LastModifiedBy!: string;
    LastModified!: string;
    AppraisalRejected!: boolean;
    ActiveIndex!: number;
    LastAppraisalDate!: string;
    LastAnnualAppraisalDate!: string;
    NextAppraisalDate!: string;
    WorkflowSteps!: string;
    PostedAppraisalDate!: string;
    SendToAccountingDate!: string;
    ScheduleNCost!: number;
    Currency!: string;
    Derivative!: number;

    //Commercial Mortgage
    Country!: string;
    PropertyValueAsIs!: number;
    CapRateAsIs!: number;
    PropertyValueAsIsDate!: string;
    PropertyValueStabilized!: number;
    CapRateStabilized!: number;
    PropertyValueStabilizedDate!: string;
    ReportDate!: string;

    PropertyLandValue!: number; //LandValue
    PropertyInsurableValue!: number; //Insurablevalue

    ShowDelete!: boolean;
    Asset!: Asset[];

    IsDeleted!: boolean;
}


export class GetAppraisalModel {
    appraisalId!: string;
    status!: string;
    valueDate!: string;
    appraiser1!: ApplicationUser;
    appraiser2!: ApplicationUser;
    appraiser3!: ApplicationUser;
    fiduciary!: ApplicationUser;
    appraiserFirm!: string;
    externalAppraiser!: string;
    appraisalType!: string;
    currentAppraisalValue!: number;
    currentPrincipalValue!: number;
    loanToValueRatio!: number;
    treasuryRate!: number;
    riskPremium!: number;
    surveyYield!: number;
    percentageChange!: string;
    annualPercentageChange!: string;
    investmentId!: string;
    investmentName!: string;
    fund!: string;
    created!: string;
    fundId!: string;
    investmentType!: string;
    investmentPropertyType!: string;
    city!: string;
    state!: string;
    hasDebtLiability!: boolean;
    lastAppraisedValue!: number;
    lastAnnualAppraisedValue!: number;
    assetManager!: ApplicationUser;
    portfolioManager!: ApplicationUser;
    assetManagerHead!: ApplicationUser;
    sectorHead!: ApplicationUser;
    claimedBy!: ApplicationUser;
    workflowId!: string;
    stage!: string;
    xmin!: number;
    canSubmit!: boolean;
    createdBy!: string;
    reated!: string;
    lastModifiedBy!: string;
    lastModified!: string;
    appraisalRejected!: boolean;
    activeIndex!: number;
    lastAppraisalDate!: string;
    lastAnnualAppraisalDate!: string;
    nextAppraisalDate!: string;
    workflowSteps!: string;
    postedAppraisalDate!: string;
    sendToAccountingDate!: string;
    scheduleNCost!: number;
    currency!: string;
    derivative!: number;
    valuationType!: string; 
    //Commercial Mortgage
    country!: string;
    propertyValueAsIs!: number;
    capRateAsIs!: number;
    propertyValueAsIsDate!: string;
    propertyValueStabilized!: number;
    capRateStabilized!: number;
    propertyValueStabilizedDate!: string;
    reportDate!: string;

    propertyLandValue!: number; //LandValue
    propertyInsurableValue!: number; //Insurablevalue

    frequency!: string;

    showDelete!: boolean;
    assets: AppraisalAssetsModel[] = [];
    gpAppraisalValue!:number;
    isDeleted!: boolean;
}
export class AuditLog {
    id !: string;
    appraisalId !: string;
    previousStatus !: string;
    status !: string;
    approverName !: string;
    approverEmail !: string;
    workflowId !: string;
    taskStatus !: string;
    taskComments !: string;
    xmin !: number;
    createdBy !: string;
    created !: string;
    lastModifiedBy !: string;
    lastModified !: string;
}

export class AuditTemplate{
    status!:string;
    createdBy!:string;
    date!:string;
    comments!:string;
} 


export class AppraisalTask {
    appraisalid!: string;
    appraisalStatus!: string;
    approver!: string;
    firstname!: string;
    lastname!: string;
    approverEmail!: string;
    taskStatus!: boolean;
    previousStatus!: string;
    workflowId!: string;
    status!:string;
    comments!: string;
    createdBy!: string;
    created!: string;
    lastModifiedBy!: string;
    lastModified!: string;
    taskComments!:string;
    approverName!:string;
}

export class AppraisalRevokedRequest {
    Id!: string;
    UerEmail!: string;
    Comments!: string;
}